import { gql, useLazyQuery } from '@apollo/client'
import { Attachment as AttachmentIcon, Edit as EditIcon } from '@mui/icons-material'
// import { catch } from 'fetch-mock'
import { useCallback, useContext, useRef, useState } from 'react'
import {
  Button,
  Datagrid,
  DateField,
  DeleteButton,
  FileInput,
  ResourceContextProvider,
  SimpleForm,
  TextField,
  useDataProvider,
  useRecordContext,
  useRefresh,
} from 'react-admin'
import { AutocompleteFreeSolo, CreateModal, EditModal, Empty, FileImageField } from '~/components'
import { StorageContext, uploadBlob } from '~/helpers'

export const EditAttachments = (props) => {
  const { relation, stateCreate } = props
  // const [images, setImages] = useState([])
  const storage = useContext(StorageContext)

  const [getAttachmentTypes, { data }] = useLazyQuery(gql`
    {
      attachments(distinct_on: type) {
        type
      }
    }
  `)
  let attachmentsTypes = (data ? data.attachments : []).map((data) => data.type || '')
  const refresh = useRefresh()
  // react-admin 4 removed the generic useMutation; call the dataProvider
  // directly for these ad-hoc writes.
  const dataProvider = useDataProvider()
  const mutate = ({ type, resource, payload }) => dataProvider[type](resource, payload)

  const refCreateCanvas = useRef(null)
  const createAttachment = useCallback(
    async ({ type, file }) => {
      //const blob = await new Promise((resolve) => refCreateCanvas.current.toBlob(resolve))
      const blob = file.rawFile
      //const blob = refCreateCanvas.current.files[0]

      //Adding this block to prevent from crashing
      //try {
      const data = await uploadBlob(blob, file, storage, relation[0])

      const [relName, relId] = relation

      await mutate(
        {
          type: 'create',
          resource: 'attachments',
          payload: {
            data: {
              type,
              uri: data.key,
              relation: relName,
              relation_id: parseInt(relId),
              title: file.title,
              content_type: data.ContentType,
              md5: data.md5,
            },
          },
        },
        { returnPromise: true }
      )
      refresh()
      stateCreate[1](false)
      console.log(data)
    },
    [stateCreate, mutate, refresh, relation, storage]
  )

  const stateEditModal = useState(false)
  const [editAttachmentId, edit] = useState(0)
  // const refEditCanvas = useRef(null)
  const editAttachment = useCallback(
    async ({ id, type, file }) => {
      let fileInfo = {}
      if (file) {
        const blob = file.rawFile
        const data = await uploadBlob(blob, file, storage, relation[0])
        fileInfo = {
          uri: data.key,
          title: file.title,
          content_type: data.ContentType,
          md5: data.md5,
          // A new file: whatever logo the old one carried is gone with it.
          logo_box: null,
        }
      }

      // const [relName, relId] = relation
      await mutate(
        {
          type: 'update',
          resource: 'attachments',
          payload: {
            id,
            data: {
              type,
              updated_at: new Date(),
              ...fileInfo,
            },
          },
        },
        { returnPromise: true }
      )
      refresh()
      stateEditModal[1](false)
    },
    [stateEditModal, mutate, refresh, storage]
  )

  // todo: move this somehow to editdialog and add button to datagrid
  // can't figure out how to access List from Create-, EditModal (has to be possible)
  const EditModalButton = (props) => {
    const { source } = props
    const record = useRecordContext(props)
    return (
      <Button
        onClick={(e) => {
          edit(record.id)
          stateEditModal[1](true)
        }}
        label='ra.action.edit'
      >
        <EditIcon />
      </Button>
    )
  }

  const ImageFieldFoo = (props) => {
    const { source, ...rest } = props
    const record = useRecordContext(props)
    return (
      <FileImageField
        record={record}
        source={source}
        typeSource='content_type'
        title='title'
        target='_blank'
        {...rest}
      />
    )
  }

  /* const selectFiles = (event) => {
    let images = []

    for (let i = 0; i < event.target.files.length; i++) {
      images.push(URL.createObjectURL(event.target.files[i]))
    }

    setImages(images)
  } */

  return (
    <>
      <ResourceContextProvider value='attachments'>
        <Empty {...props} icon={<AttachmentIcon />} resource='attachments' create={false}>
          <Datagrid expand={<ImageFieldFoo source='uri' />} rowClick='expand'>
            <TextField source='id' label='#' />
            <TextField source='type' label='resources.attachments.fields.type' />
            <DateField source='created_at' label='resources.comments.fields.created_at' />
            <DateField source='updated_at' label='resources.comments.fields.updated_at' />
            <EditModalButton />
            <DeleteButton redirect={false} />
          </Datagrid>
        </Empty>
      </ResourceContextProvider>

      <CreateModal
        title='resources.attachments.create'
        state={stateCreate}
        {...props}
        resource='attachments'
      >
        <SimpleForm onSubmit={createAttachment}>
          <AutocompleteFreeSolo
            source='type'
            label='Type'
            getChoices={getAttachmentTypes}
            choices={attachmentsTypes}
          />
          {/* <FileInputPreview source='uri' refCanvas={refCreateCanvas} label='' /> */}
          {/* <input
            type='file'
            source='uri'
            onChange={(evt) => selectFiles(evt)}
            multiple={true}
            ref={refCreateCanvas}
          />
          {images.map((image) => (
            <img src={image} />
          ))} */}
          <FileInput source='file' label='' refCanvas={refCreateCanvas}>
            <FileImageField source='src' title='title' />
          </FileInput>
        </SimpleForm>
      </CreateModal>

      <EditModal state={stateEditModal} {...props} resource='attachments' id={editAttachmentId}>
        <SimpleForm onSubmit={editAttachment}>
          <AutocompleteFreeSolo
            source='type'
            label='Type'
            getChoices={getAttachmentTypes}
            choices={attachmentsTypes}
          />
          <ImageFieldFoo source='uri' fullWidth />
          <FileInput source='file' label='' refCanvas={refCreateCanvas}>
            <FileImageField source='src' title='title' />
          </FileInput>
        </SimpleForm>
      </EditModal>
    </>
  )
}

export default EditAttachments
